/**
* Email validation
*/

const orderEmail = () => {
  const inputField = document.querySelector(".is-email");
  if(!inputField) return
  const submitBtn = document.querySelector('.js-order-submit-btn')
  const input:any = inputField.querySelector('input[type="email"]');
  const error = inputField.querySelector('.form__error');
  const errorMsg = "メールアドレスが正しくありません。";
  if (!input || !error || !submitBtn) return;

  submitBtn.addEventListener("click", (e) => {
    if(input.value == "") {
      error.classList.add("show");
      error.innerHTML = errorMsg
    }
  })
  
  const regex = /^(?=[^@]*[A-Za-z])([a-zA-Z0-9])(([a-zA-Z0-9])*([\._-])?([a-zA-Z0-9]))*@(([a-zA-Z0-9\-])+(\.))+([a-zA-Z]{2,4})+$/i;
  input.addEventListener("keyup", () => {
    //@ts-ignore
    if (!regex.test(input.value)) {
      error.classList.add("show");
      error.innerHTML = errorMsg

      if(input.value == "") {
        error.innerHTML = errorMsg
      }
    }
    else {
      error.classList.remove("show");
    }
  })
}

export default orderEmail
